import { render, staticRenderFns } from "./SushiDiaoxianItem.vue?vue&type=template&id=4d965e42&scoped=true&"
import script from "./SushiDiaoxianItem.vue?vue&type=script&lang=js&"
export * from "./SushiDiaoxianItem.vue?vue&type=script&lang=js&"
import style0 from "./SushiDiaoxianItem.vue?vue&type=style&index=0&id=4d965e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d965e42",
  null
  
)

export default component.exports